import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { SubscriptionBundlesVM } from '../../viewModel/subscriptionBundles.viewModel';

type ConfirmPriceDisableModalProps =
  SubscriptionBundlesVM['confirmPriceDisableModal'];

export const ConfirmPriceDisableModal: React.FC<
  ConfirmPriceDisableModalProps
> = ({ isOpen, save, close, disabledPrice }) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    title="Exclusive Access price change"
    modalClassName="w-full md:w-[670px]"
  >
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        gap: 'xl',
      })}
    >
      {disabledPrice.monthly && <DetailsCard isMonthly={true} />}
      {disabledPrice.annual && <DetailsCard isMonthly={false} />}
      <div
        className={sprinkles({
          display: 'flex',
          gap: 'l',
          justifyContent: 'end',
          alignItems: 'center',
        })}
      >
        <Button
          variant="text"
          color="neutral"
          onClick={close}
          className="w-[220px]"
          data-testid="subscription-cancel-price-change"
        >
          Cancel
        </Button>
        <Button
          color="neutral"
          onClick={save}
          className="w-[200px]"
          data-testid="subscription-confirm-price-change"
        >
          Save
        </Button>
      </div>
    </div>
  </Modal>
);

type DetailsCardProps = { isMonthly: boolean };

const DetailsCard: React.FC<DetailsCardProps> = ({ isMonthly }) => (
  <div
    className={sprinkles({
      display: 'flex',
      flexDirection: 'column',
      gap: 'l',
      p: 'l',
      borderRadius: 'm',
      bg: 'N-10',
    })}
  >
    <Typography variant="body" size="small" fontWeight="bold">
      {isMonthly ? 'MONTHLY' : 'ANNUAL'} SUBSCRIBERS
    </Typography>
    <div
      className={sprinkles({
        display: 'flex',
        flexDirection: 'column',
        gap: '2xl',
      })}
    >
      <Typography variant="body" fontWeight="normal">
        There are <b>existing {isMonthly ? 'monthly' : 'annual'} subscribers</b>{' '}
        who will continue to have access to this subscription until they
        unsubscribe.
      </Typography>
      <Typography variant="body" fontWeight="normal">
        But no new user is going to be able tu subscribe on
        {isMonthly ? ' a monthly' : ' an annual'} basis.
      </Typography>
    </div>
  </div>
);
